import { datadogRum } from "@datadog/browser-rum";
import { ErrorInfo } from "react";

export type AddReactErrorOptions = {
  error: Error;
  info: ErrorInfo;
};

export function addReactError(
  name: string,
  { error, info }: AddReactErrorOptions
) {
  const datadogRumError = new Error(error.message);
  datadogRumError.name = name;
  datadogRumError.stack = info.componentStack ?? undefined;
  datadogRumError.cause = error;
  datadogRum.addError(datadogRumError);
}
